
import { Vue } from 'vue-class-component';

export default class TransportCostIndex extends Vue {
}
